var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "third-step-box" },
    [
      _c("div", { staticClass: "form" }, [
        _c(
          "div",
          { staticClass: "form-item" },
          [
            _c("p", { staticClass: "label required-fields" }, [
              _vm._v(_vm._s(_vm.$t("8000164")))
            ]),
            _vm._v(" "),
            _c(
              "van-radio-group",
              {
                on: { change: _vm.changeRadio },
                model: {
                  value: _vm.thirdTemp.isTokenWillingness,
                  callback: function($$v) {
                    _vm.$set(_vm.thirdTemp, "isTokenWillingness", $$v)
                  },
                  expression: "thirdTemp.isTokenWillingness"
                }
              },
              [
                _c(
                  "van-radio",
                  {
                    attrs: { name: "1" },
                    scopedSlots: _vm._u([
                      {
                        key: "icon",
                        fn: function(props) {
                          return [
                            _c("svg-icon", {
                              attrs: {
                                "icon-class": props.checked
                                  ? "xuanzhong2"
                                  : "moren1"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  },
                  [_vm._v(_vm._s(_vm.$t("8000169")))]
                ),
                _vm._v(" "),
                _vm.thirdTemp.isTokenWillingness == 1
                  ? _c("van-field", {
                      staticClass: "value",
                      class: { errorClass: !!_vm.emailLimitMsg },
                      attrs: {
                        type: "textarea",
                        rows: "1",
                        autosize: "",
                        clearable: "",
                        autocomplete: "off",
                        placeholder: _vm.$t("8000170")
                      },
                      on: {
                        focus: function($event) {
                          _vm.emailLimitMsg = ""
                        },
                        blur: _vm.handleEmailBlur
                      },
                      model: {
                        value: _vm.thirdTemp.email,
                        callback: function($$v) {
                          _vm.$set(_vm.thirdTemp, "email", $$v)
                        },
                        expression: "thirdTemp.email"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.emailLimitMsg
                  ? _c("span", { staticClass: "error-msg-style" }, [
                      _vm._v(_vm._s(_vm.emailLimitMsg))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "van-radio",
                  {
                    attrs: { name: "0" },
                    scopedSlots: _vm._u([
                      {
                        key: "icon",
                        fn: function(props) {
                          return [
                            _c("svg-icon", {
                              attrs: {
                                "icon-class": props.checked
                                  ? "xuanzhong2"
                                  : "moren1"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  },
                  [_vm._v("\n          " + _vm._s(_vm.$t("8000168")))]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-item" },
          [
            _c("p", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("8000171")))
            ]),
            _vm._v(" "),
            _c("van-field", {
              staticClass: "value",
              attrs: {
                type: "textarea",
                rows: "1",
                autosize: "",
                maxlength: "50",
                clearable: "",
                autocomplete: "off",
                placeholder: _vm.$t("8000172")
              },
              model: {
                value: _vm.thirdTemp.referral,
                callback: function($$v) {
                  _vm.$set(_vm.thirdTemp, "referral", $$v)
                },
                expression: "thirdTemp.referral"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tip-message-box" }, [
          _c("h2", { staticClass: "bold title" }, [
            _vm._v(_vm._s(_vm.$t("300166")) + "：")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("8000159")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("8000160")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("8000161")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("8000162")) + " ")]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("8000163")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("8000165")))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-buttons-box" },
        [
          _c(
            "van-button",
            { staticClass: "back-btn", on: { click: _vm.handleBack } },
            [_vm._v(_vm._s(_vm.$t("10000012")))]
          ),
          _vm._v(" "),
          _c(
            "van-button",
            {
              staticClass: "next-btn",
              attrs: {
                loading: _vm.submitButtonLoading,
                disabled: !!_vm.emailLimitMsg
              },
              on: { click: _vm.nextStep }
            },
            [_vm._v(_vm._s(_vm.$t("8000166")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: {
            closeable: "",
            "close-icon": "cross",
            "close-icon-position": "top-right"
          },
          model: {
            value: _vm.createModel,
            callback: function($$v) {
              _vm.createModel = $$v
            },
            expression: "createModel"
          }
        },
        [
          _c(
            "div",
            { staticClass: "create-tip-msg" },
            [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  class: _vm.isDirection ? "mirrorRotateLevel" : "",
                  attrs: { "aria-hidden": "true" }
                },
                [_c("use", { attrs: { "xlink:href": "#icon-Vector5" } })]
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("8000167", {
                      currency:
                        _vm.$parent.currency + "/USDT-" + _vm.$parent.memo,
                      upFee: _vm.$parent.upFee
                    })
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "service" }, [
                _c(
                  "svg",
                  {
                    staticClass: "icon pointer checkIcon",
                    attrs: { "aria-hidden": "true" },
                    on: {
                      click: function($event) {
                        _vm.checked = !_vm.checked
                      }
                    }
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xlink:href": !_vm.checked
                          ? "#icon-weixuanzhong"
                          : "#icon-xuanzhong"
                      }
                    })
                  ]
                ),
                _vm._v("\n         \n        "),
                _vm._v(" "),
                _c("div", {
                  ref: "content",
                  staticClass: "inline-block",
                  domProps: { innerHTML: _vm._s(_vm.$t("8000173")) }
                })
              ]),
              _vm._v(" "),
              _c(
                "van-button",
                {
                  attrs: {
                    loading: _vm.$parent.createSubmitStatus,
                    disabled: !_vm.checked
                  },
                  on: { click: _vm.handleSure }
                },
                [_vm._v(_vm._s(_vm.$t("8000129")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d33f6f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d33f6f6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/freeZone/createSymbol/thirdStep.vue
// module id = JCQd
// module chunks = 0